import { render } from "./section-filter-dashboard.vue?vue&type=template&id=1d057959&scoped=true&ts=true"
import script from "./section-filter-dashboard.vue?vue&type=script&lang=ts"
export * from "./section-filter-dashboard.vue?vue&type=script&lang=ts"

import "./section-filter-dashboard.vue?vue&type=style&index=0&id=1d057959&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d057959"]])

export default __exports__